import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { gql, useQuery } from 'urql';
import { XLarge } from '@outdoor-voices/ui';
import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Storage from '@outdoor-voices/ui/dist/utils/Storage';
import { COOKIES } from '../../config/constants';
import css from './DoerFlag.module.scss';
import OVApp from '../../utils/OVContext';
import useTimeout from '../../utils/hooks/useTimeout';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var DELAY_TIME = 1000;
var query = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query GetDoer($handle: String!) {\n    doers(handle: $handle) {\n      edges {\n        node {\n          fullName\n          handle\n          promoCode\n        }\n      }\n    }\n  }\n"])));

var setPromoCode = function setPromoCode(promoCode) {
  var storage = new Storage();
  var promo = {
    promoCode: promoCode,
    error: false,
    submitted: false,
    success: false
  };
  storage.set(COOKIES.PROMO, JSON.stringify(promo));
};

var DoerFlag = function DoerFlag(_ref) {
  var doer = _ref.doer;
  var storage = new Storage();
  var userClosed = storage.get(COOKIES.DOER_FLAG_CLOSED);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  useTimeout(function () {
    if (userClosed) {
      return;
    }

    setOpen(true);
  }, DELAY_TIME);

  var onClose = function onClose() {
    setOpen(false);
    storage.set(COOKIES.DOER_FLAG_CLOSED, true);
  };

  var fullName = doer && doer.fullName ? doer.fullName : 'a doer';
  return /*#__PURE__*/_jsxs("div", {
    className: cc([css.root, _defineProperty({}, css.open, open)]),
    children: [/*#__PURE__*/_jsxs("div", {
      className: css.message,
      children: [/*#__PURE__*/_jsx("p", {
        className: css.copy,
        children: "You're shopping with ".concat(fullName, ". New Customers get ")
      }), /*#__PURE__*/_jsx("p", {
        className: css.bold,
        children: "20% off first online purchase.\xA0"
      }), /*#__PURE__*/_jsx("p", {
        className: css.copy,
        children: "Code applied at checkout.\xA0"
      }), /*#__PURE__*/_jsx("a", {
        className: css.terms,
        href: "/pages/doer-promo-terms",
        children: "See terms"
      })]
    }), /*#__PURE__*/_jsx("button", {
      className: css.closeButton,
      onClick: onClose,
      type: "button",
      title: "close",
      children: /*#__PURE__*/_jsx(XLarge, {})
    })]
  });
};

DoerFlag.propTypes = {
  doer: PropTypes.shape().isRequired
};
export var DoerFlagLoader = function DoerFlagLoader(_ref3) {
  var handle = _ref3.handle;
  var variables = {
    handle: handle
  };

  var _useQuery = useQuery({
    query: query,
    variables: variables
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      data = _useQuery2$.data,
      fetching = _useQuery2$.fetching;

  if (fetching) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  var doers = data && data.doers ? data.doers.edges.map(function (_ref4) {
    var node = _ref4.node;
    return _objectSpread({}, node);
  }) : [];
  var doer = doers.length > 0 ? doers[0] : false;

  if (!doer || !doer.promoCode) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  setPromoCode(doer.promoCode);
  return /*#__PURE__*/_jsx(DoerFlag, {
    doer: doer
  });
};
DoerFlagLoader.propTypes = {
  handle: PropTypes.string.isRequired
};

var DoerFlagProvider = function DoerFlagProvider(_ref5) {
  var handle = _ref5.handle;
  return /*#__PURE__*/_jsx(OVApp, {
    children: /*#__PURE__*/_jsx(DoerFlagLoader, {
      handle: handle
    })
  });
};

DoerFlagProvider.propTypes = {
  handle: PropTypes.string.isRequired
};
export default DoerFlagProvider;